import { rem } from '@blueprint/ui';
import { Flex } from 'rebass/styled-components';

import { Typography, IconLink } from 'components/blueprint';
import { colors, oneColumnLayout } from 'themes';
import { useSafeLabel } from 'hooks';
import { useInteractionTracking } from 'tracking/hooks/useInteractionTracking';

import HorizontalRule from '../Ruler/HorizontalRule';
import messages from './messages';

const HorizontalSeparateLine = () => (
  <HorizontalRule
    marginTop={rem(20)}
    width="100%"
    sx={{
      display: 'none',
      [oneColumnLayout]: {
        display: 'block',
      },
    }}
  />
);

/**
 * SupportFooter
 * show/hide this footer on VA panel
 * on session value is 'net'
 */
export const SupportFooter = ({ onLinkClick }) => {
  const safeLabel = useSafeLabel();
  const trackLink = useInteractionTracking('button click');

  return (
    <Flex
      flexShrink="0"
      flexDirection="column"
      height={rem(80)}
      sx={{
        [oneColumnLayout]: {
          height: '100%',
        },
      }}
    >
      <HorizontalRule marginBottom={rem(20)} width="100%" />

      <Flex
        width="100%"
        height={rem(40)}
        sx={{
          [oneColumnLayout]: {
            flexDirection: 'column',
            width: '100%',
            height: '100%',
          },
        }}
      >
        <Flex
          flexDirection="column"
          width={rem(217)}
          sx={{
            borderRight: `${rem(1)} solid ${colors?.grey}`,
            [oneColumnLayout]: {
              borderRight: 'none',
              width: '100%',
            },
          }}
        >
          <IconLink
            icon="Help"
            marginRight={rem(10)}
            marginBottom={rem(5)}
            href="#/user-guides"
            target="_self"
            iconProps={{
              width: rem(20),
            }}
            onClick={trackLink({
              tealiumData: {
                event_content: 'user guides onsite link',
              },
            })}
          >
            {safeLabel(messages.userGuides)}
          </IconLink>
          <Typography marginLeft={rem(27)} variant="body2">
            {safeLabel(messages.userGuideDesc)}
          </Typography>
        </Flex>
        <HorizontalSeparateLine />

        <Flex
          flexDirection="column"
          marginLeft={rem(27)}
          width={rem(286)}
          sx={{
            borderRight: `${rem(1)} solid ${colors?.grey}`,
            [oneColumnLayout]: {
              marginLeft: 0,
              width: '100%',
              borderRight: 'none',
              marginTop: rem(20),
            },
          }}
        >
          <IconLink
            icon="ContactMessage"
            marginRight={rem(10)}
            marginBottom={rem(5)}
            href="#/message-centre"
            target="_self"
            iconProps={{
              width: rem(20),
            }}
            onClick={trackLink({
              tealiumData: {
                event_content: 'message centre onsite link',
              },
            })}
          >
            {safeLabel(messages.contactMessage)}
          </IconLink>
          <Typography marginLeft={rem(27)} variant="body2">
            {safeLabel(messages.contactMessageDesc)}
          </Typography>
        </Flex>
        <HorizontalSeparateLine />
        <Flex
          flexDirection="column"
          width={rem(212)}
          marginLeft={rem(27)}
          sx={{
            [oneColumnLayout]: {
              width: '100%',
              marginTop: rem(20),
              marginLeft: 0,
            },
          }}
        >
          <IconLink
            tabIndex="0"
            role="link"
            icon="ContactPhone"
            marginRight={rem(10)}
            marginBottom={rem(5)}
            iconProps={{
              width: rem(20),
            }}
            onClick={trackLink({
              tealiumData: {
                event_content: 'telephone numbers onsite link',
              },
              onClick: () =>
                onLinkClick('How can I contact the HSBCnet Support team'),
            })}
          >
            {safeLabel(messages.contactPhone)}
          </IconLink>

          <Typography
            marginLeft={rem(27)}
            variant="body2"
            marginRight={rem(10)}
          >
            {safeLabel(messages.contactPhoneDesc)}
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  );
};
